import { API_MODE } from "@/lib/api/helpers";
import { cn } from "@/lib/utils";

/**
 * Where this console's data comes from, said once in the sidebar footer.
 *
 * It used to be the literal string "Mock adapter · demo data" in both sidebars
 * (S-247), which the console kept showing while every screen was reading the
 * deployed gateway — on stage that sentence tells the audience the numbers are
 * fake. The badge now derives from the one switch that decides the source,
 * `VITE_API_MODE`, and names the gateway origin when there is one to name; in
 * dev the requests go same-origin through the Vite proxy, so "this origin" is
 * the honest description there.
 */
export function DataSourceBadge({ className }: { className?: string }) {
  const live = API_MODE === "http";
  const base = import.meta.env.VITE_API_BASE_URL as string | undefined;
  const where = live ? (base && base.length > 0 ? base : "this origin") : undefined;
  return (
    <div
      data-testid="data-source"
      data-mode={live ? "http" : "mock"}
      className={cn("flex items-center gap-2 rounded-md border bg-muted/40 px-2.5 py-2", className)}
    >
      <span className={cn("size-1.5 shrink-0 rounded-full", live ? "bg-ok" : "bg-muted-foreground/60")} />
      {/* Console wording ruling (2026-10-08): "Connected", the gateway on hover only. */}
      <span className="truncate text-xs text-muted-foreground" title={where}>
        {live ? "Connected" : "Mock adapter · demo data"}
      </span>
    </div>
  );
}
